import { render, staticRenderFns } from "./image-size-control.vue?vue&type=template&id=cb642e16&scoped=true&"
import script from "./image-size-control.vue?vue&type=script&lang=js&"
export * from "./image-size-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb642e16",
  null
  
)

export default component.exports